import { CancelToken } from 'axios';
import { GroupUserSearchParams, searchUsers } from '@front-app/services/GroupsApi/GroupsApi';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { ThrottledSearch, useThrottledApi } from './useThrottledApi';

const cancellableSearchUsers = (token: CancelToken, groupId: string, params: GroupUserSearchParams) => searchUsers(groupId, params, token);

type UserSearchArgs = [string, GroupUserSearchParams];

export const useThrottledUsersSearch = (): ThrottledSearch<UserSearchArgs, UserSearchItem[]> => useThrottledApi(
	cancellableSearchUsers,
	{
		shouldShortCircuit: (groupId: string, params: GroupUserSearchParams) => !params.name,
		emptyResultFactory: () => [],
		catchAndReturnEmptyOnCancellation: true,
	},
);
